import 'reflect-metadata';
import { AnalyticsProvider } from '@components/shared/analytics-provider.component.tsx';
import { HelmetWrapper } from '@components/shared/helmet.component.tsx';
import { config } from '@config';
import { initializeSentry } from '@utils/sentry.util.ts';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app.tsx';
import '@fontsource-variable/sora';
import 'country-flag-icons/3x2/flags.css';
import './main.css';
import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';
import { queryClient } from '@queries/client.ts';
import { QueryClientProvider } from '@tanstack/react-query';

initializeSentry();

const root = document.getElementById('root') as HTMLElement;

if (!config.auth0.clientId || !config.auth0.domain) {
  throw new Error('Missing Auth0 configuration');
}

const providerConfig: Auth0ProviderOptions = {
  authorizationParams: {
    audience: config.auth0.audience,
    redirect_uri: window.location.origin,
    scope: 'openid profile email offline_access',
  },
  clientId: config.auth0.clientId,
  domain: config.auth0.domain,
  useRefreshTokens: true,
};

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <Auth0Provider {...providerConfig}>
      <QueryClientProvider client={queryClient}>
        <AnalyticsProvider>
          <HelmetWrapper />
          <App />
        </AnalyticsProvider>
      </QueryClientProvider>
    </Auth0Provider>
  </React.StrictMode>,
);
